import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './hooks/useAuth';
import App from './App';
import { CookieNotice } from './components/ui/CookieNotice';
import { initAnalytics } from './lib/firebase';
import { initOaiq } from './lib/oaiq';
import { initMetaPixel } from './lib/metaPixel';
import './index.css';

initAnalytics();
// OpenAI/ChatGPT Ads pixel. Self-gates on consent and on prod-vs-dev, so this
// is safe to call unconditionally; it also captures ?oppref= for attribution.
initOaiq();
// Meta Pixel. Same self-gating; must run while ?fbclid= is still in the URL.
initMetaPixel();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
          <CookieNotice />
          <Toaster
            position="top-right"
            toastOptions={{
              style: {
                background: '#000000',
                border: '1px solid rgba(91, 58, 58, 0.3)',
                color: '#FFFBFE',
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
